export const radians = Math.PI / 180;
export const degrees = 180 / Math.PI;



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-transition/node_modules/d3-color/src/math.js